import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
import React from "react";
import RightArrow from "../SVGComponents/RightArrow";
import LeftArrow from "../SVGComponents/LeftArrow";

const NextPreviousSection = (props) => {
  return (
    <div
      style={{
        // marginTop: props.isMobile?"0px":"25px",
        display: "flex",
        justifyContent: "end",
        flexDirection: "row",
        width: "100%",
        height: "100%",
      }}
      className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
    >
      {props.prevDisabled ? (
        <div
          style={{ cursor: !props.prevDisabled ? "pointer" : "not-allowed",display:'flex',alignItems:'center',alignItem:'center' }}
          onClick={!props.prevDisabled ? props.handlePreviousClick : null}
        >
          <LeftArrow active={!props.prevDisabled} />
        </div>
      ) : (
        // <DefaultButton
        //   style={
        //     props.prevDisabled
        //       ? {
        //           cursor: "not-allowed",
        //           background: "#605E5C",
        //           borderRadius: "5px",
        //         }
        //       : {}
        //   }
        //   text={t("hospital.previous")}
        //   onClick={props.handlePreviousClick}
        //   disabled={props.prevDisabled}
        // />
        <div
          style={{ cursor: !props.prevDisabled ? "pointer" : "not-allowed",display:'flex',alignItems:'center',alignItem:'center' }}
          onClick={!props.prevDisabled ? props.handlePreviousClick : null}
        >
          <LeftArrow active={!props.prevDisabled} />
        </div>
        // <PrimaryButton
        //   style={{
        //     background: "#2F80ED",
        //     borderRadius: "5px",
        //   }}
        //   text={t("hospital.previous")}
        //   onClick={props.handlePreviousClick}
        // />
      )}
      {props.handleNextClick != null && props.handleNextClick != undefined ? (
        // <PrimaryButton
        //   style={{
        //     background: "#2F80ED",
        //     borderRadius: "5px",
        //   }}
        //   text={t("hospital.next")}
        //   onClick={props.handleNextClick}
        // />

        props.nextDisabled ? (
          <div
            style={{ cursor: !props.nextDisabled ? "pointer" : "not-allowed",marginLeft:'15px',display:'flex',alignItems:'center',alignItem:'center' }}
            onClick={!props.nextDisabled ? props.handleNextClick : null}
          >
            <RightArrow active={!props.nextDisabled} />
          </div>
        ) : (
          // <DefaultButton
          //   style={
          //     props.nextDisabled
          //       ? {
          //           cursor: "not-allowed",
          //           background: "#605E5C",
          //           borderRadius: "5px",
          //         }
          //       : {}
          //   }
          //   text={t("hospital.next")}
          //   onClick={props.handleNextClick}
          //   disabled={props.nextDisabled}
          // />

          <div
            style={{ cursor: !props.nextDisabled ? "pointer" : "not-allowed",marginLeft:'15px',display:'flex',alignItems:'center',alignItem:'center' }}
            onClick={!props.nextDisabled ? props.handleNextClick : null}
          >
            <RightArrow active={!props.nextDisabled} />
          </div>

          // <PrimaryButton
          //   style={{
          //     background: "#2F80ED",
          //     borderRadius: "5px",
          //   }}
          //   text={t("hospital.next")}
          //   onClick={props.handleNextClick}
          // />
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default NextPreviousSection;
